import { Provider } from 'react-redux'
import { getOrCreateStore } from '@wellesley/store'
import { useWebSocket } from '@wellesley/ws'
import { useAuthTokenWatcher, handleWlsyVersionChange } from '@wellesley/auth'
import { useSentryUser, sentryClient } from '@wellesley/sentry'

import config from './config'
import { useAccountWsUpdate } from '@wellesley/user'
import useUpdateMyProfile from '../common/hooks/useUpdateMyProfile'
import { useGetApiV1InstanceQuery } from '@wellesley/instanceinfo'
import {
  CustomToastContainer,
  useNotifications,
  usePushNotificationSetup,
} from '@wellesley/notifications'
import { SystemToastContainer } from '@wellesley/system-toast'
import { TooltipProvider, useDeviceTypeUpdater } from '@wellesley/ui'

import {
  useFetchPlatformSettings,
  useProfileSettings,
} from '@wellesley/settings'
import { Router } from './Router'
import { useNetworkStatusListener } from '@wellesley/network'
import { useHostEventsListeners } from '@wellesley/host-remote'

void handleWlsyVersionChange()

const { sentry } = config()

sentryClient.init(sentry)

const Hooks = () => {
  useNetworkStatusListener()
  useDeviceTypeUpdater()
  useAuthTokenWatcher()
  useWebSocket()
  useSentryUser()
  useUpdateMyProfile()
  useAccountWsUpdate()
  useNotifications()
  usePushNotificationSetup()
  useHostEventsListeners()
  useGetApiV1InstanceQuery()
  // TODO need to split settings, pass keys to this hook, maybe in other places too
  useFetchPlatformSettings()
  useProfileSettings()

  return null
}

export const App = () => (
  <Provider store={getOrCreateStore()}>
    <Hooks />
    <TooltipProvider>
      <SystemToastContainer />
      <CustomToastContainer />
      <Router />
    </TooltipProvider>
  </Provider>
)
